import React from "react";
import "./ExperienceCard.scss";

export default function ExperienceCard({cardInfo, index}) {
  const GetDescBullets = ({descBullets}) => {
    return descBullets
      ? descBullets.map((item, i) => (
          <li key={i} className="subTitle">
            {item}
          </li>
        ))
      : null;
  };

  return (
    <article className="experience-card">
      <div className="experience-marker"></div>
      <div className="experience-card-inner">
        <div className="experience-meta">
          <span className="experience-index">
            {String(index + 1).padStart(2, "0")}. -
          </span>
          <img
            className="experience-roundedimg"
            src={cardInfo.companylogo}
            alt={cardInfo.company}
          />
          <div>
            <h5 className="experience-text-company">{cardInfo.company}</h5>
            <p className="experience-text-date">{cardInfo.date}</p>
          </div>
        </div>
        <div className="experience-text-details">
          <h5 className="experience-text-role">{cardInfo.role}</h5>
          <p className="subTitle experience-text-desc">{cardInfo.desc}</p>
          <ul>
            <GetDescBullets descBullets={cardInfo.descBullets} />
          </ul>
        </div>
      </div>
    </article>
  );
}
